import { omit } from 'lodash';

import { Input, Component, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { SnSharePermissions } from '@lib/api/entities';
import { SnFormFieldConfig, SnFormOptions } from '@lib/form';
import { t } from '@lib/translation/helpers/translation.helper';

import { SnShareFieldsGeneratorService } from '../../services/share-fields-generator.service';

@Component({
  selector: 'sn-share-invite-form',
  templateUrl: './share-invite-form.component.html',
  styleUrls: ['./share-invite-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnShareInviteFormComponent implements OnChanges {
  @Input()
  public readonly form = new UntypedFormGroup({});

  @Input()
  public formModel: any = {};

  @Input()
  public additionalFields: SnFormFieldConfig[] = [];

  public formFields: SnFormFieldConfig[];
  public readonly formOptions: SnFormOptions = {};

  constructor(private readonly _shareFieldsGenerator: SnShareFieldsGeneratorService) {
    this.formFields = this._getFormFields();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.additionalFields) {
      this.formFields = this._getFormFields();
    }
  }

  public resetForm(): void {
    this.formOptions.resetModel();
  }

  public getFormData(): Object[] {
    const shares = this.formModel.shares;
    const params = omit(this.formModel, 'shares');

    return shares.map((item) => {
      return {
        target_organization: item.id,
        ...params,
      };
    });
  }

  private _getFormFields(): SnFormFieldConfig[] {
    return [
      {
        key: 'permissions',
        defaultValue: SnSharePermissions.View,
        hideExpression: true,
      },
      this._shareFieldsGenerator.getOrganizationAutocompleteField({
        className: 'organization-chips',
        templateOptions: {
          required: true,
        },
      }),
      {
        wrappers: ['form-field-group'],
        templateOptions: {
          label: t('shares.dateLimits'),
        },
        fieldGroup: [
          {
            fieldGroupClassName: 'date-row',
            fieldGroup: [
              this._shareFieldsGenerator.getStartDateField({
                className: 'start-date-col',
                templateOptions: {
                  appearance: 'outline',
                },
              }),
              this._shareFieldsGenerator.getEndDateField({
                className: 'end-date-col',
                templateOptions: {
                  appearance: 'outline',
                },
              }),
            ],
          },
        ],
      },
      {
        wrappers: ['form-field-group'],
        templateOptions: {
          label: t('shares.additionalOptions'),
        },
        hideExpression: !this.additionalFields?.length,
        fieldGroup: this.additionalFields,
      },
    ];
  }
}
